module.exports = __webpack_public_path__ + "static/media/plåster-min.73d90b5c.png";